module.exports = function(s){
	return function(n){
		if (
			(s!=null && s.repeat!==undefined) ||
			(typeof s !== 'string')
		) {
			return s.repeat(n)
		} else {
			return Array(n+1).join(s)
		}
	}
}
